import { render, staticRenderFns } from "./Scope.vue?vue&type=template&id=1aeaee9a&scoped=true"
import script from "./Scope.vue?vue&type=script&lang=js"
export * from "./Scope.vue?vue&type=script&lang=js"
import style0 from "./Scope.vue?vue&type=style&index=0&id=1aeaee9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeaee9a",
  null
  
)

export default component.exports